<template>
   <swiper class="swiper" ref="swiper" :options="swiperOptions">
    <swiper-slide v-for="(item, index) in items" :key="index">
      <CloudImage class="img" :cloud-path="item.imgSrc" cover transition="fade" gradient="to bottom, rgba(0,0,0, 0), rgba(0,0,0,.7)"></CloudImage>
      <div class="wrapper d-flex flex-column justify-end pa-6">
        <div class="title mb-4">{{item.title}}</div>
        <v-btn class="btn-detail mb-4" outlined color="#FFF" @click.stop="onClick(item)" >查看更多</v-btn>
        <div class="date">日期：{{formatTime(item.date)}}</div>
      </div>
    </swiper-slide>
    <div class="swiper-button-prev" @click="prev"></div>
    <div class="swiper-button-next" @click="next"></div>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { formatTime } from '@/utils'
import CloudImage from './CloudImage'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: { CloudImage, Swiper, SwiperSlide },
  props: {
    items: Array
  },
  data: () => ({
    swiperOptions: {
      slidesPerView: 3,
      autoplay: {
        delay: 1000
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      // loop: true,
      grabCursor: true
    }
  }),
  methods: {
    formatTime,
    onClick (item) {
      this.$emit('itemClicked', item)
    },
    prev () {
      this.swiper.slidePrev()
    },
    next () {
      this.swiper.slideNext()
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper {
  width: 100%;
  height: 400px;
  .wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 2;
    box-sizing: border-box;
    color: #FFF;
  }
  .img {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .btn-detail {
    width: 200px;
  }
}
</style>
